// The platform admin manages businesses; every other /admin screen belongs to a business.
// The slash matters: /admin/staff-qr is a business's worker list.
export const platformAdminHome = '/admin/staff/businesses';

export const isPlatformAdminScreen = (url: string): boolean =>
  url.startsWith('/admin/staff/') || url.startsWith('/admin/login');
